import { heroDarkBlock } from './hero-dark';
import { heroSplitBlock } from './hero-split';
import { pageHeaderBlock } from './page-header';
import { bento2Block } from './bento-2';
import { featuresGridBlock } from './features-grid';
import { numbersBlock } from './numbers';
import { processBlock } from './process';
import { testimonialBlock } from './testimonial';
import { imageFullBlock } from './image-full';
import { faqBlock } from './faq';
import { ctaFinalBlock } from './cta-final';
import { listingsBlock } from './listings';
import { blogGridBlock } from './blog-grid';
import { teamGridBlock } from './team-grid';
import { mediaMarqueeBlock } from './media-marquee';
import { featureSplitBlock } from './feature-split';
import { bandStatsBlock } from './band-stats';
import { statsTrendsBlock } from './stats-trends';
import { networkBlock } from './network';
import { sectoresBlock } from './sectores';
import { storyScrollytellingBlock } from './story-scrollytelling';
import { formBlock } from './form';
import { imageBlock } from './image';
import { richTextBlock } from './rich-text';
import { pricingTableBlock } from './pricing-table';
import { logosCloudBlock } from './logos-cloud';
import { tabsBlock } from './tabs';
import { timelineBlock } from './timeline';
import { videoHeroBlock } from './video-hero';
import { newsletterBlock } from './newsletter';
import { comparisonTableBlock } from './comparison-table';
import { counterStatsBlock } from './counter-stats';
import { mapEmbedBlock } from './map-embed';
import { calculatorBlock } from './calculator';
import { dividerBlock } from './divider';
import { embedBlock } from './embed';
import type { BlockDefinition } from './types';

export const blockRegistry: Record<string, BlockDefinition> = {
  'hero-dark': heroDarkBlock as BlockDefinition,
  'hero-split': heroSplitBlock as BlockDefinition,
  'page-header': pageHeaderBlock as BlockDefinition,
  'bento-2': bento2Block as BlockDefinition,
  'features-grid': featuresGridBlock as BlockDefinition,
  numbers: numbersBlock as BlockDefinition,
  process: processBlock as BlockDefinition,
  testimonial: testimonialBlock as BlockDefinition,
  'image-full': imageFullBlock as BlockDefinition,
  faq: faqBlock as BlockDefinition,
  'cta-final': ctaFinalBlock as BlockDefinition,
  listings: listingsBlock as BlockDefinition,
  'blog-grid': blogGridBlock as BlockDefinition,
  'team-grid': teamGridBlock as BlockDefinition,
  'media-marquee': mediaMarqueeBlock as BlockDefinition,
  'feature-split': featureSplitBlock as BlockDefinition,
  'band-stats': bandStatsBlock as BlockDefinition,
  'stats-trends': statsTrendsBlock as BlockDefinition,
  network: networkBlock as BlockDefinition,
  sectores: sectoresBlock as BlockDefinition,
  'story-scrollytelling': storyScrollytellingBlock as BlockDefinition,
  form: formBlock as BlockDefinition,
  image: imageBlock as BlockDefinition,
  'rich-text': richTextBlock as BlockDefinition,
  // Premium blocks
  'pricing-table': pricingTableBlock as BlockDefinition,
  'logos-cloud': logosCloudBlock as BlockDefinition,
  tabs: tabsBlock as BlockDefinition,
  timeline: timelineBlock as BlockDefinition,
  'video-hero': videoHeroBlock as BlockDefinition,
  newsletter: newsletterBlock as BlockDefinition,
  'comparison-table': comparisonTableBlock as BlockDefinition,
  'counter-stats': counterStatsBlock as BlockDefinition,
  'map-embed': mapEmbedBlock as BlockDefinition,
  calculator: calculatorBlock as BlockDefinition,
  divider: dividerBlock as BlockDefinition,
  embed: embedBlock as BlockDefinition,
};

/**
 * Legacy aliases — older content (seeds, exports) used `-v5` suffixes that
 * were never registered. These map to the canonical block so existing pages
 * keep rendering. NOTE: data shape may differ; renderers fall back to safe
 * defaults when fields are missing.
 */
const BLOCK_ALIASES: Record<string, string> = {
  'page-header-v5': 'page-header',
  'features-grid-v5': 'features-grid',
  'cifras-v5': 'numbers',
  'cta-final-v5': 'cta-final',
  'faq-v5': 'faq',
  'bento-2col-v5': 'bento-2',
  'proceso-fases-v5': 'process',
  'form-v5': 'form',
};

export function resolveBlockType(type: string): string {
  return BLOCK_ALIASES[type] ?? type;
}

export function getBlock(type: string): BlockDefinition | undefined {
  return blockRegistry[type] ?? blockRegistry[BLOCK_ALIASES[type] ?? ''];
}

export function listBlocks(): BlockDefinition[] {
  return Object.values(blockRegistry);
}

export function listBlocksByCategory() {
  return listBlocks().reduce<Record<string, BlockDefinition[]>>((acc, block) => {
    const cat = block.meta.category;
    acc[cat] ??= [];
    acc[cat].push(block);
    return acc;
  }, {});
}
